import {Component, Input} from '@angular/core';

@Component({
  selector: 'ea-ui-required-optional',
  templateUrl: './required-optional.component.html'
})
export class RequiredOptionalComponent {
	@Input() isRequired: boolean;
	@Input() label: string;

}
